import RectLinear from '../rectLinear/';
import sortableMixin from '../sortable/';
import {mixedMeasure} from '../default/';
import {setMethodsFromAttrs, setMethodFromDefaultObj} from '../../modules/util';
import _munge from './_munge';
import _scale from './_scale';
import _mark from './_mark';
import _axis from './_axis';
import _legend from './_legend';
import _region from './_region';
import _facet from './_facet';
import _tooltip from './_tooltip';
import _annotation from './_annotation';

const orients  = ['vertical', 'horizontal'];
const conditions = ['normal', 'count', 'mixed'];
const _attrs = {
  annotation: false,
  facet: false,
  normalized: false,
  mono: true, //mono 타입 사용시에 mono색상 사용여부
  orient: orients[0],
  padding: 0.05,
  stacked: false,
  showDiff: false,
  regionPadding: 0.1
};

class Bar extends sortableMixin(RectLinear) {
  constructor() {
    super(_attrs);
  }
}

function _bar() {
  let bar =  new Bar();
  return bar;
}

function update() {
 // 데이터가 바뀐 경우

 // 데이터의 계산에 영향 주는 요소가 바뀐 경우

 // 다른 화면 요소가 바뀐 경우 
}

function measureName() {
  let measures = this.measures();
  let yField;
  if (this.condition() === conditions[2]) yField = mixedMeasure.field; 
  else if (this.aggregated() && measures[0].field === mixedMeasure.field) yField = measures[0].field;
  else yField = measures[0].field + '-' + measures[0].op;
  return yField;
}

function dehighlight(selection) {
  selection.select('rect').style('fill', d => d.color);
}

function highlight(selection, highlightColor) {
  selection.select('rect').style('fill', highlightColor);
}

function muteToLegend(d) {
  this.muteLegend(this.isFacet() ? d.parent.data.key : d.data.key);
}

function demuteToLegend(d) {
  this.demuteLegend(this.isFacet() ? d.parent.data.key : d.data.key);
}

function muteFromLegend(legend) {
  if (this.isFacet()) this.muteRegions(d => d.data.key !== legend.key);
  else this.muteNodes(d => d.data.key !== legend.key);
}

function demuteFromLegend(legend) {
  if (this.isFacet()) this.demuteRegions(d => d.data.key !== legend.key);
  this.demuteNodes(d => d.data.key !== legend.key);
}

function isCount() {
  return this.condition() === conditions[1];
}

function isFacet() {
  return this.facet() && this.isNested() && !this.stacked();
}
function isMixed() {
  return this.condition() === conditions[2] ;
}

function isNested() {
  let dimensions = this.dimensions();
  let condition = this.condition();
  return dimensions.length === 2 || (condition == conditions[2] && dimensions.length === 1);
}

function isVertical() {
  return this.orient() === orients[0];
}

function renderLayout(keep) { //완벽히 처음부터 업데이트 
  this.reset(keep);
  this.renderFrame();
  _munge.call(this);
  _scale.call(this, keep); 
  this.renderCanvas();
  _axis.call(this);
  _region.call(this);
  if(this.isFacet()) {
    _facet.call(this);
  } else {
    _mark.call(this); 
  }
  _legend.call(this);
  _tooltip.call(this);
  _annotation.call(this);
}

setMethodFromDefaultObj(Bar, 'annotation', {showLabel: true, color: '#477cd2'}); //OVERRIDE: measure로 사용되는 필드 이름 자동 생성 
setMethodFromDefaultObj(Bar, 'showDiff', {neuFill: '#c0ccda', incStroke:'#477cd2', incFill: '#40bbfb', decStroke: '#f06292', decFill: '#f06292'});

Bar.prototype.measureName = measureName; //OVERRIDE: measure로 사용되는 필드 이름 자동 생성 
Bar.prototype.renderLayout = renderLayout;
Bar.prototype.update = update;
Bar.prototype.highlight = highlight;
Bar.prototype.dehighlight = dehighlight;
Bar.prototype.muteToLegend = muteToLegend;
Bar.prototype.muteFromLegend = muteFromLegend;
Bar.prototype.demuteToLegend = demuteToLegend;
Bar.prototype.demuteFromLegend = demuteFromLegend;
Bar.prototype.isCount = isCount;
Bar.prototype.isFacet = isFacet;
Bar.prototype.isMixed = isMixed;
Bar.prototype.isNested = isNested;
Bar.prototype.isVertical = isVertical;

setMethodsFromAttrs(Bar, _attrs);

export default _bar;
export {conditions};



// WEBPACK FOOTER //
// ./layouts/bar/index.js